/* @flow */
import * as React from 'react';
import { IndexRedirect, Route, Redirect } from 'react-router';

import WidgetSettingsView from './components/WidgetSettingsView';
import LinkedAccountsSettingsView from './components/LinkedAccountsSettingsView';
import IndividualPlanContainer from './components/IndividualPlanContainer';
import PrintSettingsView from './components/PrintSettingsView';
import SettingsViewRouteHandler from './routeHandlers/SettingsViewRouteHandler';
import PrivacySettingsView from './components/PrivacySettingsView';
import CommunicationSettingsContainer from './containers/CommunicationSettingsContainer';
import OrganizeClassesView from 'settings/components/OrganizeClassesView';
import UserProfileView from 'settings/components/UserProfileView';
import RequireOwnerOnEnter from 'lib/RequireOwnerOnEnter';
import RequireFeatures from 'lib/RequireFeatures';
import SETTINGS_ROUTES from 'settings/constants/SettingsRouteConstants';

const requireIndividualPlanFlag = RequireFeatures(
  ['2018.dec.canada_individual_plans'],
  (nextState, replaceWith) => {
    replaceWith('/settings/profile');
  }
);

export default (
  <Route
    path="/settings(/)"
    component={SettingsViewRouteHandler}
    onEnter={(SettingsViewRouteHandler: any).onEnter}>
    <Route path={SETTINGS_ROUTES.NOTIFICATIONS} component={CommunicationSettingsContainer} />
    <Route
      path={SETTINGS_ROUTES.WIDGETS}
      component={WidgetSettingsView}
      onEnter={RequireOwnerOnEnter}
    />
    <Route
      path={SETTINGS_ROUTES.MESSAGE_HISTORY}
      component={PrintSettingsView}
      onEnter={RequireOwnerOnEnter}
    />
    <Route path={SETTINGS_ROUTES.BLOCKED_USERS} component={PrivacySettingsView} />
    <Route path={SETTINGS_ROUTES.ARCHIVED_CLASSES} component={OrganizeClassesView} />
    <Route path={SETTINGS_ROUTES.PROFILE} component={UserProfileView} />
    <Route path={SETTINGS_ROUTES.APP_INTEGRATIONS} component={LinkedAccountsSettingsView} />
    <Route
      path={SETTINGS_ROUTES.INDIVIDUAL_PLAN}
      component={IndividualPlanContainer}
      onEnter={requireIndividualPlanFlag}
    />
    <Redirect from="/settings/chat" to={SETTINGS_ROUTES.NOTIFICATIONS} />
    <Redirect from="/settings/archived" to={SETTINGS_ROUTES.ARCHIVED_CLASSES} />
    <Redirect from="/settings/connected_accounts" to={SETTINGS_ROUTES.APP_INTEGRATIONS} />
    <IndexRedirect to={SETTINGS_ROUTES.PROFILE} />
  </Route>
);
